export default "__VITE_ASSET__bbbee82d__"